// extracted by mini-css-extract-plugin
export default {"wrapper":"WelcomeBlock_wrapper__LtTu3","container":"WelcomeBlock_container__OksNf"};